import { isString } from "@studiometa/js-toolkit/utils";
import { AbstractStorage } from "./AbstractStorage.js";
class LocalStorage extends AbstractStorage {
  get(key) {
    return this.store.getItem(key);
  }
  set(key, value) {
    this.store.setItem(key, value);
  }
  has(key) {
    return isString(this.get(key));
  }
  delete(key) {
    this.store.removeItem(key);
  }
}
export {
  LocalStorage
};
//# sourceMappingURL=LocalStorage.js.map
